export const PROXY = "";
// export const API_URL = PROXY + "https://apiwaiter.kuarasoftware.es";
export const API_URL ="https://apiwaiter.kuarasoftware.es";

//MAPBOX API
export const MAP_API_URL = "https://api.mapbox.com/geocoding/v5/mapbox.places"
export const MAP_TOKEN = 'pk.eyJ1Ijoia3VhcmFzb2Z0IiwiYSI6ImNrY3c1bHcxOTBhbncyenF2M283c2c5MzgifQ.qDxAkfUx8mSHDlIH4hW24w';

